let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3OwB4")).then(() => parcelRequire('7Cp6N'));